/* Create a new "layer" on the page, like a modal or overlay.
 *
 * const LayeredComponent = React.createClass({
 *     mixins: [LayeredComponentMixin],
 *     render: function() {
 *         // render like usual
 *     },
 *     renderLayer: function() {
 *         // render a separate layer (the modal or overlay)
 *     }
 * });
 *
 * From http://jsfiddle.net/LBAr8/
 */
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import deprecatedReactRender from "#rendering/deprecated-react-render.tsx";

const LayeredComponentMixin: any = {
    componentDidMount: function (this: any) {
        // Appending to the body is easier than managing the z-index of
        // everything on the page.  It's also better for accessibility and
        // makes stacking a snap (since components will stack in mount order).
        this._layer = document.createElement("div");
        document.body?.appendChild(this._layer);
        this._renderLayer();
    },

    componentDidUpdate: function (this: any) {
        this._renderLayer();
    },

    componentWillUnmount: function (this: any) {
        this._unrenderLayer();
        document.body?.removeChild(this._layer);
    },

    _renderLayer: function (this: any) {
        // By calling this method in componentDidMount() and
        // componentDidUpdate(), you're effectively creating a "wormhole" that
        // funnels React's hierarchical updates through to a DOM node on an
        // entirely different part of the page.

        const layerElement = this.renderLayer();
        // Renders can return null, but React.render() doesn't like being asked
        // to render null. If we get null back from renderLayer(), just render
        // a noscript element, like React does when an element's render returns
        // null.
        if (layerElement === null) {
            this._unmountLayer = deprecatedReactRender(
                <noscript />,
                this._layer,
            );
        } else {
            this._unmountLayer = deprecatedReactRender(
                layerElement,
                this._layer,
            );
        }

        if (this.layerDidMount) {
            this.layerDidMount(this._layer);
        }
    },

    _unrenderLayer: function (this: any) {
        if (this.layerWillUnmount) {
            this.layerWillUnmount(this._layer);
        }

        this._unmountLayer?.();
        this._unmountLayer = undefined;
    },
};

export default LayeredComponentMixin;
